import {Boot} from '@/project'
import VueZoomer from 'vue-zoomer'

/**
 * component zoomer
 * @param Vue
 */
const boot: Boot = ({Vue}) => {
  Vue.use(VueZoomer)
}

export default boot
